import { render, staticRenderFns } from "./recory-introduce.vue?vue&type=template&id=5328924c&scoped=true&"
import script from "./recory-introduce.vue?vue&type=script&lang=js&"
export * from "./recory-introduce.vue?vue&type=script&lang=js&"
import style0 from "./recory-introduce.vue?vue&type=style&index=0&id=5328924c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328924c",
  null
  
)

export default component.exports